<script setup lang="ts">

import {useSystemStore} from "@/stores/system.store";
import {useRouter} from "vue-router";
import {storeToRefs} from "pinia";

const {coinBalance, coinBalanceLoaded} = storeToRefs(useSystemStore());
const router = useRouter();

</script>

<template>
  <div
    v-if="coinBalanceLoaded"
    class="flex flex-row items-center justify-center hover:opacity-80 cursor-pointer"
    @click="router.push({name: 'experience'})"
  >
    <img
      src="@/assets/images/apodis-coin.png"
      alt="apodis-coin"
      class="w-7 h-7 z-10"
    >
    <p class="font-semibold text-primary text-sm bg-amber-200 pr-2 pl-4 -ml-3 rounded-lg">
      {{ coinBalance > 999999 ? "999999+" : coinBalance }}
    </p>
  </div>
</template>
